const BrazilCarbonKYCWhitelist = {
  "_format": "hh-sol-artifact-1",
  "contractName": "BrazilCarbonKYCWhitelist",
  "sourceName": "contracts/core/BrazilCarbonKYCWhitelist.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "BAD_EXPIRY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LENGTH_MISMATCH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_CHANGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "allowed",
          "type": "bool"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "TrustedSystemContractSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "walletHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "expiresAt",
          "type": "uint64"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "ref",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "WalletApproved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "walletHash",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "WalletCleared",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "walletHash",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "ref",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "WalletSuspended",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "KYC_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "SYSTEM_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "UPGRADER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "internalType": "uint64",
          "name": "expiresAt",
          "type": "uint64"
        },
        {
          "internalType": "bytes32",
          "name": "ref",
          "type": "bytes32"
        }
      ],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "wallets",
          "type": "address[]"
        },
        {
          "internalType": "uint64[]",
          "name": "expiresAts",
          "type": "uint64[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "refs",
          "type": "bytes32[]"
        }
      ],
      "name": "approveBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "canTransact",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "clear",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "wallets",
          "type": "address[]"
        }
      ],
      "name": "clearBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "isApproved",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "isSuspended",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "recordOf",
      "outputs": [
        {
          "internalType": "enum IBrazilCarbonKYCWhitelist.Status",
          "name": "rawStatus",
          "type": "uint8"
        },
        {
          "internalType": "enum IBrazilCarbonKYCWhitelist.Status",
          "name": "effectiveStatus",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "updatedAt",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "expiresAt",
          "type": "uint64"
        },
        {
          "internalType": "bytes32",
          "name": "ref",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "allowed",
          "type": "bool"
        }
      ],
      "name": "setTrustedSystemContract",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "accounts",
          "type": "address[]"
        },
        {
          "internalType": "bool[]",
          "name": "allowed",
          "type": "bool[]"
        }
      ],
      "name": "setTrustedSystemContracts",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "statusOf",
      "outputs": [
        {
          "internalType": "enum IBrazilCarbonKYCWhitelist.Status",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "internalType": "bytes32",
          "name": "ref",
          "type": "bytes32"
        }
      ],
      "name": "suspend",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "wallets",
          "type": "address[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "refs",
          "type": "bytes32[]"
        }
      ],
      "name": "suspendBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "trustedSystemContract",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default BrazilCarbonKYCWhitelist;
